<script>
    import { env } from '../Environment.svelte';

    export let title = 'es necesario crear tu cuenta personal izzi';
    export let subtitle1 =
        'para activar tu servicio, es necesario crear tu cuenta personal, de lo contrario no podrás disfrutar de tus beneficios izzi';
    export let subtitle2 =
        'nota: tu número de cuenta de servicio es diferente a las credenciales que crearás para iniciar sesión en la aplicación';
    export let buttonText = 'crear cuenta personal';
    export let buttonLink = env[env.stage].urlIzziWebAccount;
</script>

<div class="panel panel--warning">
    <img src="/assets/img/icons/warning.svg" alt="warning" />
    <h1 class="text-fs-36 fw-semibold m-t-10">{title}</h1>
    <h2 class="text-fs-15 fw-semibold m-t-10">{subtitle1}</h2>
    <p class="text-fs-13 fw-regular m-t-16">{subtitle2}</p>
    <a
        href={buttonLink}
        target="_blank"
        class="pure__button pure__button--base m-t-16">{buttonText}</a
    >
</div>
